import EmailGroupPage from '@/pages/email/EmailGroupPage.vue'
import EmailAddressPage from '@/pages/email/EmailAddressPage.vue'
import EmailAddressDetails from '@/pages/email/EmailAddressDetails.vue'
import EmailGroupDetails from '@/pages/email/EmailGroupDetails.vue'
import EmailSenderPage from '@/pages/email/EmailSenderPage.vue'
import EmailSenderDetails from '@/pages/email/EmailSenderDetails.vue'

export default [
  {
    path: '/email/emailGroup/:id',
    component: EmailGroupPage,
    props: true
  },
  {
    path: '/email/emailAddress/:idGroup',
    component: EmailAddressPage,
    props: true
  },
  {
    path: '/email/emailAddress/:mode/:idEmailAddress',
    component: EmailAddressDetails,
    props: true
  },
  {
    path: '/email/emailGroup/:mode/:idEmailGroup',
    component: EmailGroupDetails,
    props: true
  },
  {
    path: '/email/emailSender/:id',
    component: EmailSenderPage,
    props: true
  },
  {
    path: '/email/emailSender/:mode/:idEmailSender',
    component: EmailSenderDetails,
    props: true
  }
]
